import { useState, type MouseEvent } from 'react';
import {
    FormControl,
    FormHelperText,
    InputAdornment,
    InputLabel,
    OutlinedInput,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import IconButton from '@/components/ui/IconButton/IconButton';
import type { PasswordFieldProps } from './IPasswordField';
import { styles } from './styles';

const PasswordField = ({
    id,
    name,
    label,
    value,
    error,
    helperText,
    disabled,
    onChange,
    onBlur,
}: PasswordFieldProps) => {
    const [showPassword, setShowPassword] = useState(false);

    const handlePreventDefault = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
    };

    return (
        <FormControl variant="outlined" error={error} fullWidth disabled={disabled}>
            <InputLabel htmlFor={id}>{label}</InputLabel>
            <OutlinedInput
                id={id}
                label={label}
                inputProps={{ onBlur }}
                onChange={onChange}
                value={value}
                name={name}
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((p) => !p)}
                            onMouseDown={handlePreventDefault}
                            onMouseUp={handlePreventDefault}
                            edge="end"
                            disabled={disabled}
                        >
                            {showPassword ? (
                                <Visibility style={styles.svg} />
                            ) : (
                                <VisibilityOff style={styles.svg} />
                            )}
                        </IconButton>
                    </InputAdornment>
                }
                aria-describedby={`${id}-helper-text`}
            />
            <FormHelperText id={`${id}-helper-text`}>{helperText}</FormHelperText>
        </FormControl>
    );
};

export default PasswordField;
